<template>
    <nav class="new c-main-nav-2023" aria-label="Site Navigation">
        <ul class="mr-auto">
            <li class="c-main-nav-2023__item c-mega-nav-2023" data-aha-nav="healthy-living">
                <aha-nav-dropdown role="menu" position="none" extra-classes="c-top-nav__link c-cta c-cta--icon dropdown-toggle">
                    <span class="c-underline-link">Healthy Living</span>

                    <template slot="dropdown">
                        <div class="container container-fluid container-wide">
                            <a href="#" class="c-mega-nav-2023__dropdown-header mb-2">Healthly Living</a>

                            <ul class="c-mega-nav-2023__container layout-1">
                                <li>
                                    <a href="#" id="menu-group-1" class="c-mega-nav-2023__header">Health Eating</a>
                                    <ul class="c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4">
                                        <li><a href="#" class="c-mega-nav-2023__link">Add Color</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Losing Weight</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Cooking Skills</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Eat Smart</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Heart-Check Foods</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Losing Weight</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Recipes</a></li>
                                    </ul>
                                    <a href="#" id="menu-group-2" class="c-mega-nav-2023__header">Pets and Your Health / Healthy Bond for Life</a>
                                    <ul class="c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4">
                                        <li><a href="#" class="c-mega-nav-2023__link">Best Friend Fridays</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Horses Have Heart</a></li>
                                    </ul>
                                </li>
                                <li>
                                    <a href="#" id="menu-group-1" class="c-mega-nav-2023__header">Healthy Lifestyle</a>
                                    <ul class="c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4">
                                        <li><a href="#" class="c-mega-nav-2023__link">Mental Health and Well-being</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Sleep</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Stress Management</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Quit Smoking/Tobacco/Vaping</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Healthy Habits</a></li>
                                    </ul>
                                </li>
                                <li>
                                    <a href="#" id="menu-group-1" class="c-mega-nav-2023__header">Fitness</a>
                                    <ul class="c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4">
                                        <li><a href="#" class="c-mega-nav-2023__link">Fitness Basics</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Getting Active</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Staying Motivated</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Walking</a></li>
                                    </ul>
                                </li>
                                <li>
                                    <a href="#" id="menu-group-1" class="c-mega-nav-2023__header">Company Collaboration</a>
                                    <ul class="c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4">
                                        <li><a href="#" class="c-mega-nav-2023__link">Well-being Works Better</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Heart-Check Certification</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Food System Strategy</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Healthly for Life</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Health Equity in the Workforce</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </template>
                </aha-nav-dropdown>
            </li>

            <li class="c-main-nav-2023__item c-mega-nav-2023" data-aha-nav="healthy-topics">
                <aha-nav-dropdown role="menu" position="none" extra-classes="c-top-nav__link c-cta c-cta--icon dropdown-toggle">
                    <span class="c-underline-link">Healthy Topics</span>

                    <template slot="dropdown">
                        <div class="container container-fluid container-wide layout-2">
                            <a href="#" class="c-mega-nav-2023__dropdown-header mb-2">Health Topics</a>

                            <ul class="c-mega-nav-2023__container">
                                <li class="column_w_3">
                                    <a href="#" id="menu-group-1" class="c-mega-nav-2023__header">Health Topics</a>
                                    <ul class="c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4">
                                        <li><a href="#" class="c-mega-nav-2023__link">Arrythmia</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Atrial Fibrilation</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Cardiac Arrest</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Cardiac Rehab</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Cardiomyopathy</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Cholesterol</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Congenital Heart Defects</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Cardiovascular Conditions of Childhood</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Heart Attack</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Heart Failure</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Heart Valve &amp; Disease</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">High Blood Pressure</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Metabolic Syndrome</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Peripheral Artery Disease</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Stroke</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__link">Vascular Health</a></li>
                                    </ul>
                                </li>
                                <li class="border-l">
                                    <ul class="c-mega-nav-2023__links c-mega-nav-2023__links--columns mb-4">
                                        <li><a href="#" class="c-mega-nav-2023__header">Caregiver Support</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__header">Caregiver Support</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__header">Consumer Health Care</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__header">Support Network</a></li>
                                        <li><a href="#" class="c-mega-nav-2023__header">Coronavirus (COVID-19)</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </template>
                </aha-nav-dropdown>
            </li>

            <!-- <li class="c-main-nav-2023__item">
                <a class="c-top-nav__link c-cta c-cta--icon dropdown-toggle" href="#"><span class="c-underline-link">Health Topics</span></a>
            </li> -->

            <li class="c-main-nav-2023__item">
                <a class="c-top-nav__link c-cta c-cta--icon dropdown-toggle" href="#"><span class="c-underline-link">Professional</span></a>
            </li>

            <li class="c-main-nav-2023__item">
                <a class="c-top-nav__link c-cta c-cta--icon dropdown-toggle" href="#"><span class="c-underline-link">About Us</span></a>
            </li>

            <li class="c-main-nav-2023__item">
                <a class="c-top-nav__link c-cta c-cta--icon dropdown-toggle" href="#"><span class="c-underline-link">Get Involved</span></a>
            </li>
        </ul>

        <ul>
            <li class="c-main-nav-2023__item">
                <aha-nav-dropdown role="menu" position="right" extra-classes="c-top-nav__link c-cta c-cta--icon dropdown-toggle">
                    <span class="c-underline-link"><img src="assets/glyphs/flag.svg" alt="">English</span>

                    <template slot="dropdown">
                        <ul class="c-nav-dropdown__list">
                            <li class="c-nav-dropdown__item">
                                <a href="#" class="c-nav-dropdown__link">Option 1</a>
                            </li>
                            <li class="c-nav-dropdown__item">
                                <a href="#" class="c-nav-dropdown__link">Option 2</a>
                            </li>
                        </ul>
                    </template>
                </aha-nav-dropdown>
            </li>

            <li class="c-main-nav-2023__item">
                <aha-location-selector 
                    name="location-selector" 
                    search-endpoint="//jsonplaceholder.typicode.com/posts" 
                    :translations='{ "search": "Search", "or": "or", "searchResults": "Search results for", "clearResults": "Clear Results", "offices": "Offices", "address": "Address", "city": "City", "state": "State", "zipCode": "Zip Code" }'
                    :states='[{ "code": "TX", "title": "Texas" }, { "code": "NY", "title": "New York" }, { "code": "AK", "title": "Alaska" }]'>

                    <span class="c-underline-link">Location</span>

                    <template slot="content">
                        Extra Location Selector Content
                    </template>
                </aha-location-selector>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
    data() {
        return {



            }
        }
    }

</script>





// WEBPACK FOOTER //
// demo/components/nav/main-nav-2023.vue